import TripIcon24 from "@/assets/SVG/TripIcon24";
import { Modal } from "@/components";
import CustomTable from "@/components/customTable/CustomTable";
import { Button, Grid, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import CreateTripPop from "../createTripPop";

function ProjectsNeededAction({ projectsNeededAction, data }) {
  const [tripDigest, setTripDigest] = useState();
  const [selectedProject, setSelectedProject] = useState();

  const [colDefs] = useMemo(
    () => [
      [
        {
          field: "name",
          headerName: "نام",
          width: 150,
        },
        {
          headerName: "بازه",
          width: 200,
          cellRenderer: (x) => {
            return (
              <Typography
                key={`date_${x.id}`}
                fontFamily="Vazirmatn"
                sx={{ lineHeight: "unset" }}
              >
                {`${x.data?.startAt ?? ""}  -  ${x.data?.endAt ?? ""}`}
              </Typography>
            );
          },
        },
        {
          headerName: "تعداد اردوها",
          width: 120,
          cellRenderer: (x) => {
            return (
              <Typography
                key={`date_${x.id}`}
                fontFamily="Vazirmatn"
                sx={{ lineHeight: "unset" }}
              >
                {x.data?.tripDigests.length}
              </Typography>
            );
          },
        },
        {
          field: "createdAt",
          headerName: "زمان ایجاد",
          width: 150,
        },
        {
          headerName: "عملیات",
          width: 500,
          cellRenderer: (x) => {
            return (
              <Grid
                key={`op_${x.id}`}
                display={"flex"}
                flexDirection={"row"}
                alignContent={"center"}
                gap={"10px"}
              >
                {x.data.tripDigests.map((tripDigest, index) => (
                  <Button
                    key={`trip_${index}`}
                    variant="contained"
                    sx={{ fontFamily: "Vazirmatn", fontSize: "11px" }}
                    onClick={() => {
                      setTripDigest(tripDigest);
                      setSelectedProject(x.data);
                    }}
                  >
                    {`ساخت اردو - ${index + 1}`}
                  </Button>
                ))}
              </Grid>
            );
          },
        },
      ],
    ],
    [data],
  );

  return (
    <>
      {tripDigest && (
        <CreateTripPop
          selectedProject={selectedProject}
          onClose={() => setTripDigest(undefined)}
          tripDigest={tripDigest}
        />
      )}

      {!tripDigest && (
        <Grid gap="30px" display={"flex"} flexDirection={"column"}>
          <Modal title={"پروژه‌های فعال"} icon={<TripIcon24 />}>
            <CustomTable
              columns={colDefs}
              rowData={projectsNeededAction}
              needPagination={false}
            />
          </Modal>
        </Grid>
      )}
    </>
  );
}

export default ProjectsNeededAction;
